import createIcon from '../../createIcon';

/**
 * @component @name LocalActivity
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMTJDMjAgMTAuOSAyMC45IDEwIDIyIDEwVjZDMjIgNC45IDIxLjEgNCAyMCA0SDRDMi45IDQgMi4wMSA0LjkgMi4wMSA2VjEwQzMuMTEgMTAgNCAxMC45IDQgMTJDNCAxMy4xIDMuMTEgMTQgMiAxNFYxOEMyIDE5LjEgMi45IDIwIDQgMjBIMjBDMjEuMSAyMCAyMiAxOS4xIDIyIDE4VjE0QzIwLjkgMTQgMjAgMTMuMSAyMCAxMlpNMTUuNTggMTYuOEwxMiAxNC41TDguNDIgMTYuOEw5LjUgMTIuNjhMNi4yMSA5Ljk5TDEwLjQ1IDkuNzRMMTIgNS44TDEzLjU0IDkuNzVMMTcuNzggMTBMMTQuNDkgMTIuNjlMMTUuNTggMTYuOFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LocalActivity = createIcon('LocalActivity', [
  [
    'path',
    {
      d: 'M20 12C20 10.9 20.9 10 22 10V6C22 4.9 21.1 4 20 4H4C2.9 4 2.01 4.9 2.01 6V10C3.11 10 4 10.9 4 12C4 13.1 3.11 14 2 14V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V14C20.9 14 20 13.1 20 12ZM15.58 16.8L12 14.5L8.42 16.8L9.5 12.68L6.21 9.99L10.45 9.74L12 5.8L13.54 9.75L17.78 10L14.49 12.69L15.58 16.8Z',
      key: '668j9w',
    },
  ],
]);

export default LocalActivity;
